import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-error",
    templateUrl: "./error.component.html",
    styleUrls: ["./error.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorComponent implements OnInit {
  errorMessage: string = '';
  constructor(readonly route: ActivatedRoute) {
    // This is intentional.
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const reason = params['reason'];
      if (reason === 'cancel') {
        this.errorMessage =
          'No resources shown. User selected "Cancel" instead of agreeing to the FN3 manual verification. To re-try, please select the Medication label again.';
      } else {
        this.errorMessage =
          'Unable to retrieve the requested resource. If resources are not enabled, please enable them and contact CIBMTR technical support as needed.';
      }
    });
  }
}
